<template>
  <div class="p-my-product__user">
    <img class="p-my-product__photo" :src="icon" />
    <span class="p-my-product__phone">{{ name }}</span>
    <a-icon class="p-my-product__ent-icon" type="down" />

    <div class="p-my-product__loginout">
      <template v-if="!buttonText && buttons.length > 0">
        <span v-for="item in buttons" :key="item.text" @click="clickItem(item)">{{ item.text }}</span>
      </template>
      <span v-else @click="clickBtn">{{ buttonText }}</span>
    </div>
    <div class="empty-hover"></div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    buttons: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    clickItem(item) {
      this.$emit('clickItem', item)
    },
    clickBtn() {
      this.$emit('clickBtn')
    }
  }
}
</script>
<style lang="scss" scoped>
.p-my-product__user {
    cursor: pointer;
    position: relative;
    display: flex;
    height: 0.45rem;
    align-items: center;
  }
.empty-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1rem;
  background: transparent;
}
  .p-my-product__photo {
    width: 0.20rem;
    height: 0.20rem;
    vertical-align: middle;
    // border-radius: 50%;
    margin-right: 0.08rem;
  }
  .p-my-product__phone {
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.22rem;
  }
  .p-my-product__phone::after {
    content: '';
    display: inline-block;
    width: 0.1rem;
    height: 0.1rem;
    margin-left: 0.08rem;
    background: url(~@/assets/images/product/arrow-white.png) no-repeat;
    background-size: 100% 100%;
  }
  .p-my-product__ent-icon {
    display: none;
    font-size: 10px;
    margin: 0 4px;
  }
  .p-my-product__loginout {
    display: none;
    position: absolute;
    right: -0.06rem;
    width: 1.1rem;
    // bottom: -0.5rem;
    top: 0.48rem;
    background: #FFFFFF;
    box-shadow: 0 0.01rem 0.06rem 0 rgba(0, 0, 0, 0.12);
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0,0,0,.65);
    line-height: 0.48rem;
    text-align: center;
    border-radius: 0.04rem;
    & span{
      display: block;
    }
  }
  .p-my-product__loginout::before {
    position: absolute;
    right: 0.2rem;
    top: -0.05rem;
    content: '';
    display: block;
    border-bottom: 0.05rem solid #FFFFFF;
    border-left: 0.05rem solid transparent;
    border-right: 0.05rem solid transparent;
  }
  .p-my-product__loginout >span:hover {
    color: #40a9ff;
  }
  .p-my-product__user:hover {
    .p-my-product__loginout {
      display: block;
      z-index: 2;
    }
  }
</style>
